import { MessageCircle, FileSearch, ClipboardCheck } from "lucide-react";
import { Reveal } from "@/components/Reveal";

const steps = [
  {
    icon: MessageCircle,
    title: "Hubungi Kami",
    desc: "Klik butang WhatsApp dan beritahu kami keperluan pembiayaan anda. Percuma & tanpa komitmen.",
  },
  {
    icon: FileSearch,
    title: "Semakan Percuma",
    desc: "Kami semak kelayakan anda dan cadangkan pilihan pembiayaan yang paling sesuai.",
  },
  {
    icon: ClipboardCheck,
    title: "Tindakan Susulan",
    desc: "Kami bimbing anda setiap langkah sehingga selesai — telus dan tanpa bayaran tersembunyi.",
  },
];

export const ProsesMudah = () => (
  <section
    data-testid="proses-section"
    className="bg-white py-20 sm:py-28"
  >
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
      <Reveal>
        <div className="max-w-2xl">
          <p className="text-sm text-gold-dark uppercase tracking-widest font-semibold">
            Proses Mudah
          </p>
          <h2 className="mt-3 font-heading text-2xl sm:text-3xl lg:text-4xl font-bold tracking-tight text-navy">
            Hanya 3 Langkah Mudah
          </h2>
        </div>
      </Reveal>

      <div
        data-testid="proses-steps"
        className="mt-12 grid grid-cols-1 md:grid-cols-3 gap-6"
      >
        {steps.map((step, i) => (
          <Reveal key={step.title} delay={i * 0.1}>
            <div className="relative h-full rounded-2xl border border-navy/5 bg-white p-8 shadow-[0_8px_30px_rgb(0,0,0,0.04)] transition-[transform,box-shadow] duration-200 hover:-translate-y-1 hover:shadow-[0_20px_40px_rgb(0,0,0,0.08)]">
              <span className="absolute top-6 right-7 font-heading text-5xl font-bold text-gold/15 select-none">
                {String(i + 1).padStart(2, "0")}
              </span>
              <span className="inline-flex h-12 w-12 items-center justify-center rounded-xl bg-navy text-gold">
                <step.icon className="w-6 h-6" />
              </span>
              <h3 className="mt-6 font-heading text-xl font-semibold text-navy">
                {step.title}
              </h3>
              <p className="mt-3 text-sm sm:text-base text-slate-600 leading-relaxed">
                {step.desc}
              </p>
            </div>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);
